export const routePermissions = {
	leads: 'fe619356-da0f-4f19-a277-8e9b7bdea62b',
	rfp: '1141d2cd-2db4-4fa2-b00c-e48176af4438',
	prospects: 'ed955734-c7d5-48e3-84d5-bccfaf01c626',
	archived: 'd350735c-7787-433e-a36b-56f9045d7828',
	writeSales: '80af0659-9e77-4c78-8375-8acf7ee5678a',
	clients: '438b54d8-1652-4c67-b51c-b529b0e1c5c5',
	writeClients: '55bce5a0-d223-4220-8589-930e41187e3a',
	tiers: '2560f5e3-3c9a-4d36-a3ac-31ee6d4c8b64',
	plans: '7998653c-1d3b-4756-befa-41941ccf507b',
	rates: '31b0b93d-4218-4025-912f-f841c47c5926',
	files: '62513cd1-0b1b-43bb-858f-f4a11faf7075',
	procedures: 'a4faa9a5-e55d-41fc-9df7-807d105e31f7',
	renewal: '83be7671-67b7-423c-b11b-2c3d4dff19ed',
	reports: 'ef246500-a386-47f0-bc18-6c905f13ba10',
	admin: '837bf731-3347-46e8-ab4b-077fa330b08a'
};

export const reportPermissions = {
	claimSummary: '1efb75d0-5ee9-435b-8861-7dfce95f9334',
	claimUploadAudit: 'a5e061b4-9f32-4315-827b-f4baa7a2a438',
	anthemReinsurance: '29820f7b-dcbd-4a8a-a523-a99d218cd47b',
	anthemReinsuranceDetail: 'fb7a842b-ca57-4198-84ab-c6cf5f8e3ec5',
	medicalLossSummary: 'bfedb581-17ba-432e-9291-3c1d3b5dc348',
	annualDataExtract: 'f322c4d7-dadd-4375-a297-b48a2344cecb',
	tierRateChart: '80ce1b44-0942-46b4-b43d-18f706c26e2e',
	highClaimantReport: 'd83dd7fa-79a1-4ff7-8d06-adf89c197ee5'
};

